import React, { Component } from 'react';
import { deepEqual } from 'fast-equals';
import SpecialityProducts from "../blocks/SpecialityProducts/index.js";
import LifeInsurance from '../blocks/LifeInsurance.js';
import DeathDismemberment from '../blocks/DeathDismemberment.js';
import DependentLife from '../blocks/DependentLife.js';
import STD from '../blocks/STD.js';
import LTD from '../blocks/LTD.js';
import CriticalIllness from '../blocks/CriticalIllness.js';
import Drugs from '../blocks/Drugs.js';
import Healthcare from '../blocks/Healthcare.js';
import OutOfCountry from '../blocks/OutOfCountry.js';
import EFAP from '../blocks/EFAP.js';
import VirtualHealthcare from '../blocks/VirtualHealthcare.js';
import FinancialAwareness from '../blocks/FinancialAwareness.js';
import Dental from '../blocks/Dental.js';
import SpendingAccounts from '../blocks/SpendingAccounts.js';
class PlanDesignForm extends Component {
  render() {
    const {
      selectedDesignID,
      selectedClassID,
      designs,
      errors,
      whitelabel,
      isMasterSite,
      savePlanDesignBenefitInitData,
      savePlanDesignField,
      setChangesMadeFlag,
      revision
    } = this.props;
    const current = designs[selectedClassID][selectedDesignID];

    // let's delete all the none plan design stuff so we can compare the two plans correctly.
    const currentBase = {
      ...current
    };
    const revisionBase = {
      ...revision
    };
    delete currentBase.dateAdded;
    delete currentBase.dateUpdated;
    delete currentBase.pricing;
    delete currentBase.pricingSummary;
    delete revisionBase.effectiveDate;
    delete revisionBase.revisionID;
    delete revisionBase.telusDrugPlanID;
    this._specialityProductsBlock = /*#__PURE__*/React.createElement(React.Fragment, null, revision && !deepEqual(currentBase.specialityProducts, revisionBase.specialityProducts) && /*#__PURE__*/React.createElement(SpecialityProducts, {
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      specialityProducts: revision.specialityProducts,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.specialityProducts : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true,
      language: this.props.language
    }), /*#__PURE__*/React.createElement(SpecialityProducts, {
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      specialityProducts: current.specialityProducts,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.specialityProducts : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      language: this.props.language
    }));
    if (this.props.accountMeta.isPrivateLabel && (this.props.isPrivateLabelAdvisor || this.props.isMasterSite)) {
      return this._specialityProductsBlock;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, revision && !deepEqual(currentBase.lifeInsurance, revisionBase.lifeInsurance) && /*#__PURE__*/React.createElement(LifeInsurance, {
      data: revision.lifeInsurance,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.lifeInsurance : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(LifeInsurance, {
      data: current.lifeInsurance,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.lifeInsurance : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.deathDismemberment, revisionBase.deathDismemberment) && /*#__PURE__*/React.createElement(DeathDismemberment, {
      data: revision.deathDismemberment,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.deathDismemberment : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(DeathDismemberment, {
      data: current.deathDismemberment,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.deathDismemberment : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.dependentLife, revisionBase.dependentLife) && /*#__PURE__*/React.createElement(DependentLife, {
      data: revision.dependentLife,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.dependentLife : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(DependentLife, {
      data: current.dependentLife,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.dependentLife : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.std, revisionBase.std) && /*#__PURE__*/React.createElement(STD, {
      data: revision.std,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.std : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(STD, {
      data: current.std,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.std : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.ltd, revisionBase.ltd) && /*#__PURE__*/React.createElement(LTD, {
      data: revision.ltd,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.ltd : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(LTD, {
      data: current.ltd,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.ltd : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.criticalIllness, revisionBase.criticalIllness) && /*#__PURE__*/React.createElement(CriticalIllness, {
      data: revision.criticalIllness,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.criticalIllness : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(CriticalIllness, {
      data: current.criticalIllness,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.criticalIllness : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.drugs, revisionBase.drugs) && /*#__PURE__*/React.createElement(Drugs, {
      data: revision.drugs,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.drugs : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(Drugs, {
      data: current.drugs,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.drugs : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.healthcare, revisionBase.healthcare) && /*#__PURE__*/React.createElement(Healthcare, {
      data: revision.healthcare,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.healthcare : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(Healthcare, {
      data: current.healthcare,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.healthcare : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.outOfCountry, revisionBase.outOfCountry) && /*#__PURE__*/React.createElement(OutOfCountry, {
      data: revision.outOfCountry,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.outOfCountry : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(OutOfCountry, {
      data: current.outOfCountry,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.outOfCountry : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.efap, revisionBase.efap) && /*#__PURE__*/React.createElement(EFAP, {
      data: revision.efap,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.efap : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(EFAP, {
      data: current.efap,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.efap : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.virtualHealthcare, revisionBase.virtualHealthcare) && /*#__PURE__*/React.createElement(VirtualHealthcare, {
      data: revision.virtualHealthcare,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.virtualHealthcare : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(VirtualHealthcare, {
      data: current.virtualHealthcare,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.virtualHealthcare : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.financialAwareness, revisionBase.financialAwareness) && /*#__PURE__*/React.createElement(FinancialAwareness, {
      data: revision.financialAwareness,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.financialAwareness : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(FinancialAwareness, {
      data: current.financialAwareness,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.financialAwareness : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.dental, revisionBase.dental) && /*#__PURE__*/React.createElement(Dental, {
      data: revision.dental,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.dental : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(Dental, {
      data: current.dental,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.dental : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }), revision && !deepEqual(currentBase.spendingAccounts, revisionBase.spendingAccounts) && /*#__PURE__*/React.createElement(SpendingAccounts, {
      data: revision.spendingAccounts,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.spendingAccounts : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag,
      isRevisionBlock: true
    }), /*#__PURE__*/React.createElement(SpendingAccounts, {
      data: current.spendingAccounts,
      revision: revision,
      selectedClassID: selectedClassID,
      selectedDesignID: selectedDesignID,
      errors: errors ? errors.spendingAccounts : {},
      isMasterSite: isMasterSite,
      savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
      savePlanDesignField: savePlanDesignField,
      whitelabel: whitelabel,
      setChangesMadeFlag: setChangesMadeFlag
    }));
  }
}
export default PlanDesignForm;